"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditProfilePrivateInfoButton = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var semantic_ui_react_1 = require("semantic-ui-react");
var util_1 = require("../util");
var i18n_1 = __importDefault(require("../i18n"));
var withState_1 = require("../hocs/withState");
exports.EditProfilePrivateInfoButton = (0, withState_1.withState)()([
    "requestEditProfilePrivateInfo",
    "editProfilePrivateInfo",
    "setRequestEditProfilePrivateInfo",
    "setTempPrivateTags",
    "lang",
    "notesLoading",
]).memoFC(function (state) { return ((0, jsx_runtime_1.jsx)(semantic_ui_react_1.Popup, { position: "bottom center", content: i18n_1.default.privateMemoDescription, trigger: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Button, { icon: true, size: "mini", disabled: Boolean(state.editProfilePrivateInfo) ||
            Boolean(state.requestEditProfilePrivateInfo) ||
            state.notesLoading, onClick: function () {
            state.setRequestEditProfilePrivateInfo(state.user.id);
        }, children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Icon, { name: "edit" }) }) })); }, function (prev, next) {
    if (prev.lang !== next.lang)
        return false;
    if (prev.requestEditProfilePrivateInfo !== next.requestEditProfilePrivateInfo)
        return false;
    if (prev.editProfilePrivateInfo !== next.editProfilePrivateInfo)
        return false;
    return (0, util_1.isProfilePrivateInfoEqual)(prev.user.profile, next.user.profile);
});
